import ExpandableDeliveryOptions from 'components/ProductPage/DeliveryOptions/ExpandableDeliveryOptions/ExpandableDeliveryOptions';

export default ExpandableDeliveryOptions;
